export const AppConfig = {
  site_name: 'TaxZerone.com',
  org_name: 'TaxZerone LLC',
  title: 'TaxZerone®',
  description:
    'TaxZerone, an IRS-authorized e-file provider, securely simplifies the process for excise, employment tax, extension, information returns, and tax-exempt forms.',
  home_title:
    'TaxZerone is an authorized e-file service provider that supports a wide range of IRS forms.',
  site_keywords:
    'TaxZerone.com, E-filing, IRS-authorized, TaxZerone, Excise forms, Employment tax, Extension forms, Information returns, Tax-exempt filing, Form 7004, Form 4868, Form 8868, Form 990, Form 941, Form 2290, 1099 Forms, Form W-2, irs non-profit taxes, Form 990-N',
  locale: 'en',
  url: 'https://www.taxzerone.com/',
};
